module.exports = __webpack_public_path__ + "static/img/i3.7fb9c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/i3.png
// module id = kjUp
// module chunks = 3